import { gql } from "@apollo/client";

export const generateDescription = gql`
    query GenerateDescription($photo: Upload!) {
        generateDescription(photo: $photo) {
            description
            error
        }
    }
`;

export interface GenerateDescriptionQueryVariables {
    photo: Blob;
}

export interface GenerateDescriptionQueryType {
    generateDescription: {
        description?: string;
        error?: string;
    };
}
